export const SET_ATTEMPTS_NBR = 'SET_ATTEMPTS_NBR';
export const SET_MAX_SETTINGS_NBR = 'SET_MAX_SETTINGS_NBR';
export const SET_STAGE = 'SET_STAGE';
export const SET_SOLUTION_VALUE = 'SET_SOLUTION_VALUE';
export const SET_DOCTOR = 'SET_DOCTOR';
export const RESET_CALIBRATION = 'RESET_CALIBRATION';
export const SET_CURRENT_ATTEMPTS = 'SET_CURRENT_ATTEMPTS';


